import React from "react";
import { CustomCheckbox } from "./GlobalHelpers";

export function getSelectRow(props) {
  const { entities, ids, setIds, isRow, setNames, Names,Drivers, setDrivers, ordersCodes, setOrdersCodes,backgroundCheckRequired,setBackgroundCheckRequired, statusIds, setStatusIds, pharmacies, setPharmacies  } = props;

  const handleRowSelect = (row, isSelect) => {
  const currentIndex = ids.findIndex(id => id === row.id);
    if (isSelect) {
      const order = {
        id: row.id,
        name: row.firstName + " " + row.lastName,
        orderCode: row.code,
        backgroundCheckRequired: row.backgroundCheckRequired
      };
      const driver = {
        id: row.id,
        name: row.driverName,
      };
      const pharmacy = {
        value: row.pharmacyId,
        label: row.pharmacyName,
      };
      setIds((prevIds) => [...prevIds, row.id]);
      if (ordersCodes !== undefined){
        setOrdersCodes((prevIds) => [...prevIds, row.code]);
      }
      if (setPharmacies !== undefined && pharmacies !== undefined) {
        setPharmacies((prev) => [...prev, pharmacy]);
      }
      if(Names !== undefined){
        setNames((prevIds) => [...prevIds, order]);
      }
      if(Drivers !== undefined){
        setDrivers((prevIds) => [...prevIds, driver]);
      }
      if (backgroundCheckRequired !== undefined && currentIndex === -1) {
        const newBackgroundChecks = [...backgroundCheckRequired, row.backgroundCheckRequired];
        setBackgroundCheckRequired(newBackgroundChecks);
      }
      if (statusIds !== undefined) {
        const newStatusIds = [...statusIds, row.statusId];
        setStatusIds(newStatusIds);
      }
    } else {
      setIds((prevIds) => prevIds.filter((id) => id !== row.id));
      if (ordersCodes !== undefined){
      setOrdersCodes((prevIds) => prevIds.filter((code) => code !== row.code));
      }
      if(Names !== undefined){
      setNames((prevIds) => prevIds.filter((el) => el.id !== row.id));
      }
      if(Drivers !== undefined){
        setDrivers((prevIds) => prevIds.filter((el) => el.id !== row.driverName));
      }
      if (backgroundCheckRequired !== undefined && currentIndex !== -1) {
        setBackgroundCheckRequired(backgroundCheckRequired.filter((_, index) => index !== currentIndex));
      }
      if (statusIds !== undefined) {
        setStatusIds(statusIds.filter((_, index) => index !== currentIndex));
      }
      if (setPharmacies !== undefined && pharmacies !== undefined) {
        setPharmacies(pharmacies.filter((_, index) => index !== currentIndex));
      }
    }
  };
  
  const handleSelectAll = (isSelect, rows) => {
    const allNames = rows.map((el) => ({ id: el.id, name: el?.firstName + " " + el?.lastName }));
    const allDrivers = rows.map((el) => ({ id: el.id, name: el?.driverName }));
    const allOrdersCodes = rows.map((el) => el.code);
    const allBackgroundChecks = rows.map((el) => el.backgroundCheckRequired);
    const allStatusIds = rows.map((el) => el.statusId);
    const pharmacies = rows.map((el) => ({ value: el.pharmacyId, label: el?.pharmacyName}));
    if (isSelect) {
      setIds(rows.map((row) => row.id));
      if (Names !== undefined) {
        setNames(allNames);
      }
      if (allDrivers !== undefined && setDrivers !== undefined) {
        setDrivers(allDrivers);
      }
      if (setOrdersCodes !== undefined) {
        setOrdersCodes(allOrdersCodes);
      }
      if (setBackgroundCheckRequired !== undefined) {
        setBackgroundCheckRequired(allBackgroundChecks);
      }
      if (setPharmacies !== undefined && pharmacies !== undefined) {
        setPharmacies(pharmacies);
      }
      if (setStatusIds !== undefined) {
        setStatusIds(allStatusIds);
      }
    } else {
      setIds([]);
      if(Names !== undefined) {
        setNames([])
      }
      if(Drivers !== undefined) {
        setDrivers([])
      }
      if (setOrdersCodes !== undefined) {
        setOrdersCodes([]);
      }
      if (setBackgroundCheckRequired !== undefined) {
        setBackgroundCheckRequired([]);
      }
      if (statusIds !== undefined) {
        setStatusIds([]);
      }
    }
  };

  return {
    mode: 'checkbox',
    clickToSelect: false,
    selected: ids,
    onSelect: handleRowSelect,
    onSelectAll: handleSelectAll,
    selectionRenderer: (props) => <CustomCheckbox {...props} />,
    selectionHeaderRenderer: (props) => <CustomCheckbox {...props} />,
  };
}